'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');
var nthBitHeader = require('@narvar/nth-bit-header');
var PageWrapper = require('./layout/PageWrapper.js');
var SessionContext = require('../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const MerchantNotLive = _ref => {
  let {
    children
  } = _ref;
  const {
    claimsMerchantNotLiveHeader,
    claimsMerchantNotLiveSupportButtonText
  } = nthHookTranslations.useTranslations();
  const {
    assistEnabled,
    supportUrl
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    devMode
  } = SessionContext.useSession();
  if (assistEnabled || devMode) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper["default"], null, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h1",
    containerCustomStyle: {
      margin: '1.5rem 0 2rem 0'
    }
  }, claimsMerchantNotLiveHeader), supportUrl && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    href: supportUrl
  }, claimsMerchantNotLiveSupportButtonText)));
};
var MerchantIsLiveCheck = nthHookTranslations.withTranslationsProvider(nthHookGlobalSettings.withGlobalSettingsProvider(MerchantNotLive, {
  globalSettingsRequested: `
      assistEnabled
      supportUrl
    `
}), {
  translationKeys: ['claimsMerchantNotLiveHeader', 'claimsMerchantNotLiveSupportButtonText']
});

exports["default"] = MerchantIsLiveCheck;
